export default {"src":"/_next/static/media/water_64.db41920d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};